import { useEffect } from 'react';
import { useTimeout, useUserContext, IApiCallStatus } from '../common';
import { signout } from '.';
import { right, left, map as emap } from 'fp-ts/lib/Either';
import { compose as lcompose, always as lalways } from 'lodash/fp';

export function useSignout({
  refreshTokenStatus,
}: {
  refreshTokenStatus: IApiCallStatus;
}) {
  const {
    user: { accessTokenExpirationDelay },
    setUser,
  } = useUserContext();

  const { resetTimeout } = useTimeout(
    lcompose(signout(setUser)),

    accessTokenExpirationDelay,
    'sign-out'
  );

  useEffect(
    () =>
      lcompose(lalways(void 0), emap(resetTimeout), refreshTokenStatus =>
        refreshTokenStatus === true
          ? right(refreshTokenStatus)
          : left(refreshTokenStatus)
      )(refreshTokenStatus),

    [refreshTokenStatus, resetTimeout]
  );
}
